import { ClientConnectCustomFieldSet } from "./types";

interface CustomTypeConfig {
    type: string;
    element: string;
    pname: string;
}

const getCustomTypeConfig = (customType?: string): CustomTypeConfig => {
    try {
        const isDocument = (customType && customType === 'document');
        return {
            type: isDocument ? 'Document' : 'Field',
            element: isDocument ? 'CustomDocumentSets' : 'CustomFieldSets',
            pname: isDocument ? 'ClientConnectCustomDocumentSets' : 'ClientConnectCustomFieldSets'
        };
    } catch (e) {
        console.log(`Unable to get Custom ${customType} Sets: `, e)
        return {
            type: 'Field',
            element: 'CustomFieldSets',
            pname: 'ClientConnectCustomFieldSets'
        };
    }
}

export const saveCustomFieldSet = async (sid: string, fieldSet: ClientConnectCustomFieldSet, customType?: string): Promise<boolean> => {
    const { type, element, pname } = getCustomTypeConfig(customType);
    try {
        const finalFieldSets = [];
        const previousCustomFieldSets = await getCustomFieldSet(sid, customType);

        for (let i = 0; i < previousCustomFieldSets.length; i++) {
            finalFieldSets.push(previousCustomFieldSets[i]);
            if (fieldSet.fieldSetName === previousCustomFieldSets[i].fieldSetName) {
                alert(`${type} Set Name already exists!`)
                return false;
            }
        }

        finalFieldSets.push(fieldSet);

        fetch(`saveprofile.asp?pname=${pname}&SessionID=${sid}`, {
            method: "POST",
            body: `<Root><${element}><![CDATA[${JSON.stringify(finalFieldSets)}]]></${element}></Root>`
        });
        return true;
    } catch (e) {
        console.log(`Unable to save Custom ${type} Sets: `, e)
        return false;
    }
}

export const updateCustomFieldSet = async (sid: string, fieldSet: ClientConnectCustomFieldSet, editFieldSet: ClientConnectCustomFieldSet, customType?: string): Promise<boolean> => {
    const { type, element, pname } = getCustomTypeConfig(customType);
    try {
        const finalFieldSets = [];
        const previousCustomFieldSets = await getCustomFieldSet(sid, customType);
        for (let i = 0; i < previousCustomFieldSets.length; i++) {
            if (editFieldSet.fieldSetName === previousCustomFieldSets[i].fieldSetName) {
                previousCustomFieldSets.splice(i, 1, fieldSet);
            }
            finalFieldSets.push(previousCustomFieldSets[i]);
        }

        if (checkForDuplicateFieldSetNames(finalFieldSets, customType)) {
            fetch(`saveprofile.asp?pname=${pname}&SessionID=${sid}`, {
                method: "POST",
                body: `<Root><${element}><![CDATA[${JSON.stringify(finalFieldSets)}]]></${element}></Root>`
            });
            return true;
        } else {
            return false;
        }
    } catch (e) {
        console.log(`Unable to update Custom ${type} Sets: `, e)
        return false;
    }
}

export const getCustomFieldSet = async (sid: string, customType?: string): Promise<ClientConnectCustomFieldSet[]> => {
    const { type, element, pname } = getCustomTypeConfig(customType);
    try {
        var res = await fetch(`getprofile.asp?pname=${pname}&SessionID=${sid}`);
        var textData = await res.text();
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(textData, "text/xml");
        const customFieldSetXMLString = xmlDoc.getElementsByTagName(element)[0]?.childNodes[0]?.nodeValue;
        if (customFieldSetXMLString) {
            const customFieldSetArray: ClientConnectCustomFieldSet[] = JSON.parse(customFieldSetXMLString);
            return customFieldSetArray;
        } else {
            return []
        }
    } catch (e) {
        console.log(`Unable to get Custom ${type} Sets: `, e);
        return [];
    }
}

export const deleteCustomFieldSet = async (sid: string, fieldSetDelete: ClientConnectCustomFieldSet, customType?: string) => {
    const { type, element, pname } = getCustomTypeConfig(customType);
    try {
        const previousCustomFieldSets = await getCustomFieldSet(sid, customType);
        const finalFieldSets = previousCustomFieldSets.map(v => {
            if (fieldSetDelete.fieldSetName === v.fieldSetName) return;
            return v;
        }).filter(v => v);
        fetch(`saveprofile.asp?pname=${pname}&SessionID=${sid}`, {
            method: "POST",
            body: `<Root><${element}><![CDATA[${JSON.stringify(finalFieldSets)}]]></${element}></Root>`
        });
        return true;
    } catch (e) {
        console.log(`Unable to delete Custom ${type} Sets: `, e)
        return false;
    }
}

export const checkForDuplicateFieldSetNames = (finalFieldSets: ClientConnectCustomFieldSet[], customType?: string): boolean => {
    const { type } = getCustomTypeConfig(customType);
    // Set to store unique field set names
    const uniqueFieldSetNames = new Set();
    // Flag to determine whether there are duplicate field set names
    let hasDuplicates = false;
    for (let j = 0; j < finalFieldSets.length; j++) {
        const currentFieldSet = finalFieldSets[j];
        // Check if the field set name has already been encountered
        if (uniqueFieldSetNames.has(currentFieldSet.fieldSetName)) {
            hasDuplicates = true;
            break; // Break out of the loop if there are duplicates
        }
        // Add the current field set name to the set
        uniqueFieldSetNames.add(currentFieldSet.fieldSetName);
    }
    if (hasDuplicates) {
        alert(`${type} Set Name already exists!`)
        return false;
    } else {
        return true;
    }
}